define.alias("ember-math-helpers/helpers/sum", "preview-grid/helpers/sum");